import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";

//Redux
import {
  deleteCourse,
  getCourse,
  editCourse,
  saveCourse,
} from "../../../redux/descriptorsProfiles/Courses/actions";
import messages from "../../../redux/messages";
import { getMeasurementUnit } from "../../../redux/descriptorsProfiles/MeasurementUnit/actions";

const Courses = (props) => {
  const filters = [
    { id: "nombre", desc: "Nombre del Curso" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});

  //
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  //
  const [measurementUnitSelected, setMeasurementUnitSelected] = useState([]);

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre del Curso",
  });

  const dispatch = useDispatch();

  //Validacion del form
  const schema = Yup.object().shape({
    nombre: Yup.string()
      .required("**Campo requerido")
      .matches(
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
        "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
      ),
    duracion: Yup.number()
      .positive()
      .test(
        "maxDigitsAfterDecimal",
        "El número debe tener 2 despues del punto o menos",
        (number) => /^\d{1,20}(\.\d{1,2})?$/.test(number)
      ),
    unidad_medida: Yup.string().required("**Campo requerido"),
  });

  const {
    loading,
    saveLoading,
    coursesLength,
    courses,
    coursesError,
    formError,
  } = useSelector((store) => store.course);

  const pages = Math.ceil(coursesLength / limit);

  const { measurementUnits, measurementUnitError, measurementUnitsLength } =
    useSelector((store) => store.measurementUnit);
  const loadingMeasurementUnit = useSelector(
    (store) => store.measurementUnit.loading
  );

  let measurementUnitOptions = [];
  if (measurementUnits && measurementUnits) {
    measurementUnits.map((item) => {
      measurementUnitOptions = [
        ...measurementUnitOptions,
        { id: item.id, label: item.descripcion },
      ];
    });
  }

  //Datos para el custom table

  const columns = [
    {
      Header: "Nombre del curso",
      accessor: "nombre",
    },
    {
      Header: "Duración del curso",
      accessor: "duracion",
    },
    {
      Header: "Unidad de medida",
      accessor: "list_unidad_medida[0].descripcion",
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos de cursos

  const getACourse = (off = offset, lim = limit, filt = filter) =>
    dispatch(
      getCourse({
        offset: off,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    getACourse();
    dispatch(getMeasurementUnit({}));
  }, []);

  const addCourse = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    if (item.unidad_medida) {
      setMeasurementUnitSelected([
        {
          id: item.unidad_medida,
          label: item.list_unidad_medida[0].descripcion,
        },
      ]);
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    getACourse(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      ...req,
      nombre: req.nombre,
      duracion: req.duracion,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };

    if (!edit) {
      dispatch(saveCourse(_req, setShowModal));
    } else {
      dispatch(editCourse(_req, editItem.id, index, setShowModal));
    }
    setMeasurementUnitSelected([]);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACourse(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCourse(id, index));
      window.alert("Se borró este curso");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6>CURSOS</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      onClick={() => addCourse()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            coursesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={courses} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={coursesLength}
                  pages={pages}
                  pagFunc={getACourse}
                />
              </>
            )
          )}
          {!loading && coursesLength === 0 && coursesError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
          {!!coursesError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {coursesError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setMeasurementUnitSelected([]);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            duracion: edit ? editItem.duracion : "",
            unidad_medida: edit
              ? editItem.unidad_medida === null
                ? ""
                : editItem.unidad_medida
              : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar curso" : "Crear curso"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Curso / Diplomado / Seminario o Pasantía:
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill mb-4"
                    type="text"
                    placeholder="Nombre"
                  ></Form.Control>
                  <Form.Label column sm="12" md="12">
                    Duracion:
                  </Form.Label>
                  <Form.Control
                    id="duracion"
                    name="duracion"
                    isInvalid={touched.duracion && errors.duracion}
                    isValid={touched.duracion && !errors.duracion}
                    onBlur={handleBlur("duracion")}
                    onChange={handleChange}
                    value={values.duracion}
                    className="rounded-pill mb-4"
                    type="text"
                    placeholder="Duración del curso"
                  ></Form.Control>
                  <Form.Label column sm="12" md="12">
                    Unidad de medida
                  </Form.Label>
                  <Typeahead
                    id="unidad_medida"
                    name="unidad_medida"
                    isInvalid={touched.unidad_medida && errors.unidad_medida}
                    isValid={touched.unidad_medida && !errors.unidad_medida}
                    onBlur={handleBlur("unidad_medida")}
                    placeholder="Seleccione una opción"
                    options={measurementUnitOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "unidad_medida",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setMeasurementUnitSelected(selected);
                    }}
                    selected={measurementUnitSelected}
                    disabled={measurementUnitsLength === 0}
                  ></Typeahead>
                  {loadingMeasurementUnit && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.unidad_medida && errors.unidad_medida && (
                    <Col>
                      <small className="text-danger">
                        {errors.unidad_medida}
                      </small>
                    </Col>
                  )}
                  {!!measurementUnitError && (
                    <Col>
                      <small className="text-danger">
                        **{measurementUnitError}
                      </small>
                    </Col>
                  )}
                  {!loadingMeasurementUnit && measurementUnitsLength === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron funciones
                      </small>
                    </Col>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={saveLoading}
                  type="submit"
                >
                  {" "}
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Courses;
